import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polyline, { points: "14 9 9 4 4 9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M20 20h-7a4 4 0 0 1-4-4V4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "CornerLeftUp";
const CornerLeftUp = memo(themed(Icon));
export {
  CornerLeftUp
};
//# sourceMappingURL=corner-left-up.js.map
